import { useEffect } from 'react';

/**
 * Casino idle-session keepalive.
 *
 * Seamless casinos (WOW Vegas / Gametech) expire a player's session after
 * ~15 idle minutes, and only calls that reach the casino count as activity —
 * clicks inside the iframe don't. A player who browses for 20 minutes and
 * then rips would hand the backend an expired operator token, and the debit
 * fails. Polling GET /balance (→ the operator's get_balance) every
 * `intervalSec` seconds resets that timer for as long as the game is open.
 *
 * `intervalSec` ≤ 0 (every operator without the setting) or no session
 * installs nothing. Background tabs are fine: browsers throttle timers to
 * ≥ 1/min, still well inside the casino window for any allowed interval.
 */
export function useBalanceKeepalive(
  intervalSec: number,
  enabled: boolean,
  refresh: () => Promise<number | null>,
): void {
  useEffect(() => {
    if (!enabled || intervalSec <= 0) return;
    const id = window.setInterval(() => void refresh(), intervalSec * 1000);
    return () => window.clearInterval(id);
  }, [intervalSec, enabled, refresh]);
}
